export * from "./FixedValueTranslator";
export * from "./ElementNameTranslator";
export * from "./NameTranslator";
export * from "./PrintBehaviorTranslator";
export * from "./LocationTranslator";
export * from "./SizeTranslator";
export * from "./LineStyleTranslator";
export * from "./TextureStyleTranslator";
export * from "./QuoteBehaviorTranslator";
export * from "./EditBehaviorTranslator";
export * from "./TooltipBehaviorTranslator";
export * from "./RelationTranslator";
export * from "./NameHistoriesTranslator";
export * from "./BookmarkTranslator";
export * from "./ItemsTranslator";
export * from "./BarcodeStyleTranslator";
export * from "./BarcodeItemsTranslator";
export * from "./LineGraphItemsTranslator";
export * from "./ImageStyleTranslator";
export * from "./CategoryNameTranslator";
export * from "./FontSizeAutoAdjustBehaviorTranslator";
export * from "./LineBreakBehaviorTranslator";
export * from "./TextAreaStyleTranslator";
export * from "./NaturalTextBehaviorTranslator";
export * from "./GroupAlertBehaviorTranslator";
export * from "./EmptyAlertBehaviorTranslator";
export * from "./LengthAlertBehaviorTranslator";
export * from "./FreeInputBehaviorTranslator";
export * from "./TextSearchBehaviorTranslator";
export * from "./MultiLineBehaviorTranslator";
export * from "./PageExtendBehaviorTranslator";
export * from "./TextObjectKindTranslator";
export * from "./InputRuleBehaviorTranslator";
export * from "./InputMethodBehaviorTranslator";
export * from "./TextJoinBehaviorTranslator";
export * from "./TurnedTextStyleTranslator";
export * from "./NumberStyleTranslator";
export * from "./NumberRangeAlertBehaviorTranslator";
export * from "./FocusBehaviorTranslator";
export * from "./PaintStyleOnEditingTranslator";
export * from "./ItemsStyleTranslator";
export * from "./ItemGroupSelectBehaviorTranslator";
export * from "./HisInformationItemDefaultSelectBehaviorTranslator";
export * from "./HospitalizedHisInformationItemSelectBehaviorTranslator";
export * from "./UserDefinedInformationSourceTranslator";
export * from "./UserDefinedInformationWindowKindTranslator";
export * from "./UserDefinedItemSelectBehaviorTranslator";
export * from "./DesignatedDoctorTypeTranslator";
export * from "./DesignatedDoctorInformationSourceTranslator";
export * from "./CopyLinkedTextsBehaviorTranslator";
export * from "./ComboSelectBehaviorTranslator";
export * from "./RollSelectBehaviorTranslator";
export * from "./ScriptExecuteBehaviorTranslator";
export * from "./LinkedScriptExecuteBehaviorTranslator";
export * from "./ScriptTableBehaviorTranslator";
export * from "./DecimalRoundBehaviorTranslator";
export * from "./RelationReplacer";
export * from "./ILinkedObjectTranslatable";
export * from "./LinkedObjectTranslator";
export * from "./LinkedPageObjectTranslator";
export * from "./LinkedObjectGroupTranslator";
export * from "./LegacyLinkedPageObjectTranslator";
export * from "./ObjectReferableFeatureTranslator";
export * from "./ObjectReferencesTranslator";
export * from "./ObjectControllableFeatureTranslator";
export * from "./ObjectTargetsTranslator";
export * from "./DateObjectKindTranslator";
export * from "./DateCalculateBehaviorTranslator";
export * from "./TranscribeBehaviorTranslator";
export * from "./TranscribeDateOfTimeBehaviorTranslator";
export * from "./EmptyAlertAllowBehaviorTranslator";
export * from "./GroupAlertAllowBehaviorTranslator";
export * from "./ScriptExecuteTriggerBehaviorTranslator";
export * from "./ItemSelectTriggerBehaviorTranslator";
export * from "./PatientProfileCheckKindTranslator";
export * from "./ExpressionBehaviorTranslator";
export * from "./CalculationConditionalExpressionBehaviorTranslator";
export * from "./QuestionnaireTranslator";
